angular.module('unica_track.track_controllers')

.controller('TrackCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	TrackCreateService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.trackData = {
		event_id: $stateParams.event_id,
	};

	$scope.saveTrack = function()
	{
		$scope.showLoader();

		var trackData = angular.copy($rootScope.trackData);

		TrackCreateService
			.create( trackData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Track aggiunto con successo!', '');

					$state.go('app.track.list', { event_id: $stateParams.event_id });
				}
			});
	};

});

